'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseIcons = require('@bibliocommons/base-icons');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('@bibliocommons/bootstrap/scss/mixins/_links.scss');

require('../style/ChevronHeading.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronHeading = function ChevronHeading(_ref) {
  var tag = _ref.tag,
      text = _ref.text,
      url = _ref.url,
      className = _ref.className;

  var HeadingTag = tag;

  var classNames = (0, _classnames2.default)('cp-chevron-heading', 'heading-medium', className);

  return _react2.default.createElement(
    HeadingTag,
    { className: classNames },
    url ? _react2.default.createElement(
      'a',
      { href: url, className: 'link-double-chevron' },
      text
    ) : text,
    _react2.default.createElement(_baseIcons.Chevron.DoubleRight, { className: 'link-icon-double-chevron' })
  );
};

ChevronHeading.propTypes = {
  tag: _react.PropTypes.string,
  url: _react.PropTypes.string,
  className: _react.PropTypes.string,
  text: _react.PropTypes.string.isRequired
};

ChevronHeading.defaultProps = {
  tag: 'h1',
  className: ''
};

exports.default = ChevronHeading;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/headings/lib/components/ChevronHeading.js
// module id = 649
// module chunks = 5 9